module.exports = __webpack_public_path__ + "img/SketchPngfa77dfe3a27b34ab0fe1ba7ab5dbbb513e31394b862d03ba6f6f9a407daa7ea4.1d04a838.png";